import { QuestionCircleIcon } from '@mm/icons';
import classNames from 'classnames';
import React, { CSSProperties } from 'react';
import { colors } from '../../../beta/styles/colors';
import './NeedHelpLabel.scss';

type Props = {
  link: string;
  iconOnly?: boolean;
  style?: CSSProperties;
  color?: string;
  className?: string;
};

export const NeedHelpLabel = (props: Props) => {
  const { link, iconOnly, style, color, className } = props;

  return (
    <div className={classNames('need-help-container', className)} style={style}>
      <a href={link} target="_blank" rel="noopener noreferrer">
        {iconOnly ? (
          <QuestionCircleIcon color={color || colors.accentBlue} />
        ) : (
          <div className="need-help-link">
            <QuestionCircleIcon
              color={color || colors.accentBlue}
              className="need-help-icon"
            />{' '}
            Need help?
          </div>
        )}
      </a>
    </div>
  );
};
